import { getRootFontSizePx, parseFontSizeRem } from './proposalRichTextFonts';

/**
 * Taille en rem : mark inline textStyle, style inline, ou computed (CSS composant).
 */
export function getSelectionFontSizeRem(editor) {
  if (!editor || editor.isDestroyed) return null;

  const rootPx = getRootFontSizePx(editor.view?.dom?.ownerDocument);
  const fromMark = parseFontSizeRem(editor.getAttributes('textStyle')?.fontSize, rootPx);
  if (fromMark != null) return fromMark;

  const { view } = editor;
  if (!view) return null;

  try {
    const { from } = editor.state.selection;
    const dom = view.domAtPos(from);
    let el = dom.node;
    if (el.nodeType === Node.TEXT_NODE) el = el.parentElement;
    if (!(el instanceof HTMLElement)) return null;

    let node = el;
    while (node && node !== view.dom) {
      const inline = parseFontSizeRem(node.style?.fontSize, rootPx);
      if (inline != null) return inline;
      node = node.parentElement;
    }

    return parseFontSizeRem(window.getComputedStyle(el).fontSize, rootPx);
  } catch {
    return null;
  }
}

/** @deprecated Préférer {@link getSelectionFontSizeRem} */
export function getSelectionFontSizePx(editor) {
  const rem = getSelectionFontSizeRem(editor);
  if (rem == null) return null;
  const rootPx = getRootFontSizePx(editor.view?.dom?.ownerDocument);
  return rem * rootPx;
}
